import { ReduxAction } from 'app/redux/types';

import { EntriesStateType } from '../constants';

// ---

type TilePayload = {
  id: number;
  namespace: EntriesStateType;
};

// ---

export const OPEN_TILE = 'MY_STAKES:OPEN_TILE';

export type OpenTile = ReduxAction<typeof OPEN_TILE, TilePayload>;

export const openTile = (stakeItemId: number, namespace: EntriesStateType): OpenTile => ({
  type: OPEN_TILE,
  payload: {
    namespace,
    id: stakeItemId,
  },
});

// ---

export const CLOSE_TILE = 'MY_STAKES:CLOSE_TILE';

export type CloseTile = ReduxAction<typeof CLOSE_TILE, TilePayload>;

export const closeTile = (stakeItemId: number, namespace: EntriesStateType): CloseTile => ({
  type: CLOSE_TILE,
  payload: {
    namespace,
    id: stakeItemId,
  },
});

// ---

export const CLOSE_BOTH_TILES = 'MY_STAKES:CLOSE_BOTH_TILES';

export type CloseBothTiles = ReduxAction<typeof CLOSE_BOTH_TILES, { id: number }>;

export const closeBothTiles = (stakeItemId: number): CloseBothTiles => ({
  type: CLOSE_BOTH_TILES,
  payload: {
    id: stakeItemId,
  },
});
